import React, { useState } from 'react'

import { Link, NavLink, useLocation } from 'react-router-dom'

import dashboards from './components/Dashboards/dashboards.png'
import reestr from './components/Reestr/reestr.png'

import BigCompany from './components/BigCompany/BigCompany'
import Saturn from './components/BigCompany/Saturn'
import Moon from './components/BigCompany/Moon'
import InfoBlockBigCompany from './components/BigCompany/InfoBlockBigCompany'
import SmallCompany from './components/SmallCompany/SmallCompany'
import Picture from './components/SmallCompany/Picture'
import Coffee from './components/SmallCompany/Coffee'
import InfoBlockSmallCompany from './components/SmallCompany/InfoBlockSmallCompany'
import AllNeeds from './components/AllNeeds/AllNeeds'
import GerbRF from './components/RefBook/GerbRF'
import MainBanner from './components/Banner/MainBanner'
import { Header } from './components/Header'

type SubmitData = {
    fio: string
    email: string
    phone: string
    question: string
}

const HomePage: React.FC = () => {
    const [isSending, setSending] = useState(false)
    const [data, setData] = useState<SubmitData>({
        fio: '',
        email: '',
        phone: '',
        question: '',
    })

    const isEmailValid = (email: string) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)

    const formatPhoneNumber = (digits: string) => {
        const cleaned = digits.replace(/\D/g, '').slice(0, 11)
        const parts = cleaned.length < 1 ? [''] : ['+7']

        if (cleaned.length > 1) parts.push(` (${cleaned.slice(1, 4)}`)
        if (cleaned.length >= 5) parts.push(`) ${cleaned.slice(4, 7)}`)
        if (cleaned.length >= 8) parts.push(`-${cleaned.slice(7, 9)}`)
        if (cleaned.length >= 10) parts.push(`-${cleaned.slice(9, 11)}`)

        return parts.join('')
    }

    const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const digits = e.target.value.replace(/\D/g, '')
        let newDigits = digits

        // always start with 7
        if (newDigits.startsWith('8')) newDigits = '7' + newDigits.slice(1)
        if (!newDigits.startsWith('7')) newDigits = '7' + newDigits

        setData({ ...data, phone: newDigits.slice(0, 11) })
    }

    const isFormValid =
        data.fio.trim() !== '' &&
        data.question.trim() !== '' &&
        isEmailValid(data.email) &&
        data.phone.length === 11

    const escapeHtml = (text: string): string => {
        return text
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')
    }

    const handleSubmit = async () => {
        if (!isFormValid) return

        try {
            let apiUrl: string | undefined
            if (process.env.REACT_APP_MODE == 'site') {
                apiUrl = 'https://223.noxsys.ru'
            } else {
                apiUrl = process.env.REACT_APP_API_URL
            }
            setSending(true)
            const res = await fetch(
                apiUrl + '/api/backend/v1/mail_send/submit_question_request',
                {
                    method: 'POST',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        ...data,
                        question: escapeHtml(data.question),
                    }),
                }
            )

            if (res.ok) {
                setSending(false)
                setData({
                    fio: '',
                    question: '',
                    email: '',
                    phone: '',
                })
                alert('Вопрос успешно отправлен!')
            } else {
                setSending(false)
                alert('Ошибка при отправке вопроса')
            }
        } catch (err) {
            console.error(err)
            setSending(false)
            alert('Ошибка соединения')
        }
    }
    return (
        <div className="flex flex-col w-full h-full grow text-center items-center justify-start bg-[#f0f3f5] overflow-y-auto custom-scrollbar">
            <div className="flex w-full h-24"></div>

            <div className="flex flex-col w-full gap-24 items-center justify-center pb-14">
                <Header className="flex" />

                <div className="flex flex-col w-full h-fit items-center justify-start gap-5">
                    <div className="flex w-[1200px] h-full items-center justify-start font-bold text-[48px] leading-[48px]">
                        Для компании любого масштаба
                    </div>
                    <div className="relative flex flex-row w-[1200px] gap-5">
                        <div className="absolute flex w-[220px] h-[220px] rounded-full bg-[#FFFFFF] z-1 top-[90px] left-0 font-semibold text-[26px] leading-[28px] items-center justify-center">
                            Крупным компаниям и корпорациям
                        </div>
                        <div className="absolute flex w-[110px] h-[92px] rounded-full z-1 top-[20px] left-[-50px] items-center justify-center">
                            <Saturn />
                        </div>
                        <div className="absolute flex w-[58px] h-[58px] rounded-full z-1 top-0 left-[150px] items-center justify-center">
                            <Moon />
                        </div>
                        <div className="flex w-full h-full rounded-3xl items-center justify-end">
                            <BigCompany />
                        </div>
                        <div className="flex flex-col w-[900px] bg-[#e4e7ea] rounded-3xl p-5 h-fit">
                            <InfoBlockBigCompany />
                        </div>
                    </div>
                    <div className="relative flex flex-row w-[1200px] gap-5">
                        <div className="absolute flex w-[230px] h-[230px] rounded-full bg-[#FFFFFF] z-1 top-[90px] left-[950px] font-semibold text-[26px] leading-[28px] items-center justify-center">
                            Малым и средним компаниям
                        </div>
                        <div className="absolute flex w-[110px] h-[92px] rounded-full z-1 top-[30px] left-[1150px] items-center justify-center">
                            <Coffee />
                        </div>
                        <div className="absolute flex w-[58px] h-[58px] rounded-full z-1 top-0 left-[1050px] items-center justify-center">
                            <Picture />
                        </div>
                        <div className="flex flex-col w-[900px] bg-[#e4e7ea] rounded-3xl p-5 h-fit">
                            <InfoBlockSmallCompany />
                        </div>
                        <div className="flex w-full h-full rounded-3xl items-center justify-start">
                            <SmallCompany />
                        </div>
                    </div>
                </div>

                <div className="flex flex-col w-full h-fit items-center justify-start gap-5">
                    <div className="flex flex-row w-[1200px] h-full items-center justify-start font-bold text-[48px] leading-[48px] gap-3">
                        <span>О системе</span>
                        <div>
                            <span className="text-[#407bff]">NOX</span>SYS
                        </div>
                    </div>
                    <div className="flex flex-row w-[1200px] h-[400px] gap-5">
                        <div className="relative flex flex-col w-[600px] h-full bg-[#e4e7ea] rounded-3xl p-10 items-start justify-start gap-3 overflow-hidden">
                            <div className="absolute flex top-[120px] left-[30px] w-[600px] h-[400px]">
                                <img
                                    className="w-full h-full object-cover"
                                    src={reestr}
                                    alt="Дашбоарды"
                                />
                            </div>

                            <div className="flex font-semibold text-[26px] leading-[28px] ">
                                Интерактивные реестры
                            </div>
                            <div className="flex leading-[20px] items-center justify-start text-left ">
                                Реестры, автоматизирующие полный цикл
                                планирования закупок, от создания и согласования
                                до размещения в ЕИС
                            </div>
                            <div className="flex w-full h-[200px] items-center justify-center "></div>
                        </div>
                        <div className="relative flex flex-col w-[700px] h-full bg-[#e4e7ea] rounded-3xl p-10 items-start justify-start gap-3 overflow-hidden">
                            <div className="absolute top-[110px] left-[70px] w-[700px] h-[283px]">
                                <img
                                    className="w-full h-full object-cover"
                                    src={dashboards}
                                    alt="Дашбоарды"
                                />
                            </div>
                            <div className="flex font-semibold text-[26px] leading-[28px] ">
                                Дашборды и аналитика
                            </div>
                            <div className="flex leading-[20px] items-center justify-start text-left ">
                                Получите визуальное представление ключевых
                                показателей <br />в режиме реального времени
                            </div>
                            <div className="flex w-full h-[220px] items-center justify-center "></div>
                        </div>
                    </div>
                    <div className="flex flex-row w-[1200px] h-[200px] gap-5 ">
                        <div className="flex flex-col w-[400px] h-full bg-[#e4e7ea] rounded-3xl p-10 items-start justify-start gap-3">
                            <div className="flex font-semibold text-[26px] leading-[28px]">
                                Кроссплатформенность
                            </div>
                            <div className="flex leading-[20px] items-center justify-start text-left">
                                Работайте на всех операционных системах:
                                Windows, Unix/Linux, macOS и управляйте задачами
                                с любого устройства
                            </div>
                        </div>
                        <div className="flex flex-col w-[400px] h-full bg-[#e4e7ea] rounded-3xl p-10 items-start justify-start gap-3 ">
                            <div className="flex font-semibold text-[26px] leading-[28px] ">
                                Одна команда
                            </div>
                            <div className="flex leading-[20px] items-center justify-start text-left ">
                                Одновременная работа до 1 000 пользователей в
                                режиме реального времени
                            </div>
                        </div>
                        <div className="flex flex-col w-[400px] h-full bg-[#e4e7ea] rounded-3xl p-10 items-start justify-start gap-3 ">
                            <div className="flex font-semibold text-[26px] leading-[28px] text-left">
                                Поддержка клиентов
                            </div>
                            <div className="flex leading-[20px] items-center justify-start text-left">
                                Полное сопровождение и обучение на всех этапах
                                внедрения
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex flex-col w-full h-fit items-center justify-start gap-5">
                    <div className="flex w-[1200px] h-full items-center justify-start font-bold text-[48px] leading-[48px]">
                        Учитываем потребности любого специалиста
                    </div>
                    <div className="relative flex flex-row w-[1200px] gap-5">
                        <div className="absolute flex w-[200px] h-[200px] rounded-full bg-[#FFFFFF] z-1 top-[200px] left-[-50px] font-semibold text-[26px] leading-[28px] items-center justify-center">
                            Для <br />
                            инициатора закупок
                        </div>
                        <div className="absolute flex w-[200px] h-[200px] rounded-full bg-[#FFFFFF] z-1 top-[-20px] left-[460px] font-semibold text-[26px] leading-[28px] items-center justify-center">
                            Для <br />
                            специалиста по закупкам
                        </div>
                        <div className="absolute flex w-[200px] h-[200px] rounded-full bg-[#FFFFFF] z-1 top-[200px] left-[1050px] font-semibold text-[26px] leading-[28px] items-center justify-center">
                            Для <br />
                            руководителя
                        </div>
                        <div className="flex w-full h-full rounded-3xl items-center justify-center">
                            <AllNeeds />
                        </div>
                    </div>
                    <div className="flex flex-row w-[1200px] gap-5 ">
                        <div className="flex flex-col w-[400px] h-full bg-[#e4e7ea] rounded-3xl p-10 items-start justify-start gap-5">
                            <div className="flex flex-col w-full h-full items-center justify-center border-b border-[#d0d2d5] gap-1 pb-4">
                                <div className="flex w-full font-semibold text-[18px] leading-[20px] text-left">
                                    Отслеживайте этапы закупки
                                </div>
                                <div className="flex w-full leading-[20px] items-center justify-start text-left">
                                    Возможность отслеживать каждый этап заявки в
                                    план закупки
                                </div>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-center border-b border-[#d0d2d5] gap-1 pb-4">
                                <div className="flex w-full font-semibold text-[18px] leading-[20px] text-left">
                                    Все справочники в одном месте
                                </div>
                                <div className="flex w-full leading-[20px] items-center justify-start text-left">
                                    Все необходимые для работы классификаторы и
                                    справочники в одной системе
                                </div>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-center border-b border-[#d0d2d5] gap-1 pb-4">
                                <div className="flex w-full font-semibold text-[18px] leading-[20px] text-left">
                                    Умный помощник подскажет вам код
                                </div>
                                <div className="flex w-full leading-[20px] items-center justify-start text-left">
                                    Встроенная нейросеть которая поможет выбрать
                                    верный код ОКПД2 и ОКВЭД2
                                </div>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-center border-b border-[#d0d2d5] gap-1 pb-4">
                                <div className="flex w-full font-semibold text-[18px] leading-[20px] text-left">
                                    Забудьте про ошибки
                                </div>
                                <div className="flex w-full leading-[20px] items-center justify-start text-left">
                                    Автоматическая проверка на соответствие
                                    законодательству
                                </div>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-center gap-1">
                                <div className="flex w-full font-semibold text-[18px] leading-[20px] text-left">
                                    Делайте план самостоятельно
                                </div>
                                <div className="flex w-full leading-[20px] items-center justify-start text-left">
                                    Возможность самостоятельно формировать план
                                    закупки вашего подразделения
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col w-[400px] h-full bg-[#e4e7ea] rounded-3xl p-10 items-start justify-start gap-5 ">
                            <div className="flex flex-col w-full h-full items-center justify-center border-b border-[#d0d2d5] gap-1 pb-4">
                                <div className="flex w-full font-semibold text-[18px] leading-[20px] text-left">
                                    Автоматизация всех процессов
                                </div>
                                <div className="flex w-full leading-[20px] items-center justify-start text-left">
                                    Полная цифровизация всех процессов по
                                    планированию закупки от создания,
                                    согласования до размещения
                                </div>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-center border-b border-[#d0d2d5] gap-1 pb-4">
                                <div className="flex w-full font-semibold text-[18px] leading-[20px] text-left">
                                    Редактирование плана
                                </div>
                                <div className="flex w-full leading-[20px] items-center justify-start text-left">
                                    Создание, копирование, изменение и
                                    аннулирование позиций плана закупки прямо в
                                    системе
                                </div>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-center border-b border-[#d0d2d5] gap-1 pb-4">
                                <div className="flex w-full font-semibold text-[18px] leading-[20px] text-left">
                                    Забудьте про ручной ввод
                                </div>
                                <div className="flex w-full leading-[20px] items-center justify-start text-left">
                                    Импорт и экспорт плана Закупки с Excel,
                                    интеграция с ЕИС
                                </div>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-center border-b border-[#d0d2d5] gap-1 pb-4">
                                <div className="flex w-full font-semibold text-[18px] leading-[20px] text-left">
                                    Интеграция с ЕИС
                                </div>
                                <div className="flex w-full leading-[20px] items-center justify-start text-left">
                                    Автоматический обмен данными с ЕИС.
                                    Отправьте план закупки в ЕИС – одним кликом
                                </div>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-center gap-1">
                                <div className="flex w-full font-semibold text-[18px] leading-[20px] text-left">
                                    ЭЦП не обязательна
                                </div>
                                <div className="flex w-full leading-[20px] items-center justify-start text-left">
                                    Возможность работать с планом закупки в
                                    системе без ЭЦП
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col w-[400px] h-full bg-[#e4e7ea] rounded-3xl p-10 items-start justify-start gap-5 ">
                            <div className="flex flex-col w-full h-full items-center justify-center border-b border-[#d0d2d5] gap-1 pb-4">
                                <div className="flex w-full font-semibold text-[18px] leading-[20px] text-left">
                                    Единый план для всей организации
                                </div>
                                <div className="flex w-full leading-[20px] items-center justify-start text-left">
                                    Консолидируйте план подразделений в единый
                                    план закупки организации
                                </div>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-center border-b border-[#d0d2d5] gap-1 pb-4">
                                <div className="flex w-full font-semibold text-[18px] leading-[20px] text-left">
                                    Аналитика
                                </div>
                                <div className="flex w-full leading-[20px] items-center justify-start text-left">
                                    Интерактивные дашборды помогают следить за
                                    эффективностью закупочной деятельности
                                </div>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-center border-b border-[#d0d2d5] gap-1 pb-4">
                                <div className="flex w-full font-semibold text-[18px] leading-[20px] text-left">
                                    Согласование
                                </div>
                                <div className="flex w-full leading-[20px] items-center justify-start text-left">
                                    Проверьте и согласуйте каждую позицию плана
                                    закупки прямо в системе
                                </div>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-center border-b border-[#d0d2d5] gap-1 pb-4">
                                <div className="flex w-full font-semibold text-[18px] leading-[20px] text-left">
                                    Оптимизация всех процессов
                                </div>
                                <div className="flex w-full leading-[20px] items-center justify-start text-left">
                                    Сокращаем время создания и согласование
                                    плана закупки на 60%
                                </div>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-center gap-1">
                                <div className="flex w-full font-semibold text-[18px] leading-[20px] text-left">
                                    Экономия
                                </div>
                                <div className="flex w-full leading-[20px] items-center justify-start text-left">
                                    Не нужно покупать другие справочники,
                                    системы по согласованию, анализу - работайте
                                    в одной эко-системе
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex flex-col w-full h-fit items-center justify-start gap-5">
                    <div className="flex flex-row w-[1200px] h-full items-center justify-start font-bold text-[48px] leading-[48px] gap-3">
                        <span>Встроенные справочники</span>
                    </div>
                    <div className="flex flex-row w-[1200px] gap-5">
                        <div className="flex flex-col w-[600px] h-full items-center justify-center">
                            <div className="flex flex-col w-full h-full bg-[#e4e7ea] rounded-3xl p-10 items-center justify-center gap-3 ">
                                <div className="flex font-semibold text-[26px] leading-[28px] text-left items-center justify-center">
                                    Больше не нужно искать, анализировать коды
                                    ОКПД2 и проверять их на ограничения и
                                    требования, умный справочник системы
                                    подскажет все!
                                </div>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-center p-5 gap-3">
                                <div className="flex flex-col w-full h-full items-center justify-center border-b border-[#d0d2d5] gap-1 pb-4">
                                    <div className="flex w-full font-semibold text-[18px] leading-[20px] text-left">
                                        Перечень закупок в электронной форме
                                    </div>
                                    <div className="flex w-full leading-[20px] items-center justify-center text-left ">
                                        Встроенный перечень ТРУ закупка которых
                                        осуществляется в электронной форме
                                    </div>
                                </div>
                                <div className="flex flex-col w-full h-full items-center justify-center border-b border-[#d0d2d5] gap-1 pb-4">
                                    <div className="flex w-full font-semibold text-[18px] leading-[20px] text-left">
                                        Перечень закупок у субъектов МСП
                                    </div>
                                    <div className="flex w-full leading-[20px] items-center justify-start text-left">
                                        Встроенный перечень ТРУ закупка которых
                                        осуществляется у субъектов МСП
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="relative flex flex-col w-[600px] h-full items-center justify-center">
                            <div className="absolute flex rounded-3xl z-1 top-[14px] left-[440px] items-center justify-center overflow-hidden">
                                <GerbRF />
                            </div>
                            <div className="flex flex-col w-full h-full bg-[#e4e7ea] rounded-3xl p-10 items-start justify-start gap-3 ">
                                <div className="flex font-semibold text-[26px] leading-[28px] text-left">
                                    Все требования
                                    <br />
                                    по нацрежиму
                                    <br />
                                    согласно ПП №1875
                                </div>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-center p-5 gap-3">
                                <div className="flex flex-col w-full h-full items-center justify-center border-b border-[#d0d2d5] gap-1 pb-4">
                                    <div className="flex w-full font-semibold text-[18px] leading-[20px] text-left">
                                        Запреты
                                    </div>
                                    <div className="flex w-full leading-[20px] items-center justify-start text-left">
                                        Встроенный перечень товаров, работ,
                                        услуг в отношении которых установлен
                                        запрет
                                    </div>
                                </div>
                                <div className="flex flex-col w-full h-full items-center justify-center border-b border-[#d0d2d5] gap-1 pb-4">
                                    <div className="flex w-full font-semibold text-[18px] leading-[20px] text-left">
                                        Ограничения
                                    </div>
                                    <div className="flex w-full leading-[20px] items-center justify-start text-left">
                                        Встроенный перечень товаров, работ,
                                        услуг в отношении которых установлены
                                        ограничения
                                    </div>
                                </div>
                                <div className="flex flex-col w-full h-full items-center justify-center border-b border-[#d0d2d5] gap-1 pb-4">
                                    <div className="flex w-full font-semibold text-[18px] leading-[20px] text-left">
                                        Минимальная доля
                                    </div>
                                    <div className="flex w-full leading-[20px] items-center justify-start text-left">
                                        Минимальная обязательная доля закупок
                                        товаров, работ, услуг
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex w-full items-center justify-center">
                    <div className="flex flex-row w-[1200px] bg-[#5e6169] items-center justify-center p-10 m-3 rounded-3xl gap-10">
                        <div className="flex flex-col w-full h-full text-[#FFFFFF] text-left items-start justify-center gap-5">
                            <span className="flex items-start justify-center text-[38px] font-bold text-left">
                                Форма для связи
                            </span>
                            <span className="flex items-start justify-center text-[16px] leading-[16px] text-left">
                                Для того, чтобы задать любой вопрос, напишите
                                нам <br />и мы обязательно вам ответим!
                            </span>
                        </div>
                        <div className="flex flex-col w-full h-full items-center justify-start rounded-3xl bg-[#FFFFFF] p-10 gap-5 text-[12.8px]">
                            <div className="flex flex-col w-full h-full items-center justify-start gap-1">
                                <label className="flex text-[#8A8A8A] w-full h-full items-center justify-start">
                                    Фамилия Имя Отчество
                                </label>
                                <input
                                    className="flex border border-[#8A8A8A] w-full h-[40px] p-2 rounded-lg items-center justify-start focus:outline-none text-[16px]"
                                    value={data.fio}
                                    onChange={(e) => {
                                        setData({
                                            ...data,
                                            fio: e.target.value,
                                        })
                                    }}
                                ></input>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-start gap-1">
                                <label className="flex text-[#8A8A8A] w-full h-full items-center justify-start">
                                    Адрес электронной почты
                                </label>
                                <input
                                    className="flex border border-[#8A8A8A] w-full h-[40px] p-2 rounded-lg items-center justify-start focus:outline-none text-[16px]"
                                    value={data.email}
                                    onChange={(e) => {
                                        setData({
                                            ...data,
                                            email: e.target.value,
                                        })
                                    }}
                                    placeholder="E-mail"
                                ></input>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-start gap-1">
                                <label className="flex text-[#8A8A8A] w-full h-full items-center justify-start">
                                    Контактный телефон
                                </label>
                                <input
                                    value={formatPhoneNumber(data.phone)}
                                    onChange={handlePhoneChange}
                                    inputMode="numeric"
                                    maxLength={18}
                                    className="flex border border-[#8A8A8A] w-full h-[40px] p-2 rounded-lg focus:outline-none text-[16px]"
                                    placeholder="+7 (___) ___-__-__"
                                ></input>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-start gap-1">
                                <label className="flex text-[#8A8A8A] w-full h-full items-center justify-start">
                                    Вопрос
                                </label>
                                <textarea
                                    className="flex border border-[#8A8A8A] w-full min-h-[155px] p-2 rounded-lg items-center justify-start focus:outline-none text-[16px]"
                                    value={data.question}
                                    maxLength={2000}
                                    onChange={(e) => {
                                        setData({
                                            ...data,
                                            question: e.target.value,
                                        })
                                    }}
                                ></textarea>
                            </div>
                            <button
                                className={`flex flex-col w-full h-[50px] items-center justify-center border-2 rounded-lg text-[16px] ${isFormValid ? 'bg-[#5e6169] hover:bg-[#6a6e76] text-[#FFFFFF] border-[#5e6169]' : 'bg-gray-300 text-gray-500 border-gray-300'}`}
                                onClick={() => {
                                    if (isFormValid) handleSubmit()
                                }}
                                disabled={!isFormValid}
                            >
                                {isSending ? (
                                    <svg
                                        className="animate-spin h-5 w-5 text-[#181818] dark:text-[#FFFFFF]"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        ></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                        ></path>
                                    </svg>
                                ) : (
                                    'Отправить'
                                )}
                            </button>
                            <div className="flex flex-col w-full items-center justify-center text-[#8A8A8A] leading-[14px]">
                                <div>
                                    Заполняя форму, вы соглашаетесь на обработку
                                    персональных данных в соответствии с{' '}
                                    <a
                                        className="text-sky-600 hover:text-sky-400"
                                        href="#/docs/privacy-policy"
                                        target="_blank"
                                    >
                                        политикой конфиденциальности
                                    </a>{' '}
                                    <br /> и получение информационных сообщений
                                    от ООО «Технологии Закупок»{' '}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomePage
